// This scope is supplied by the provider; legacy messages are not backfilled.
export const DM_COUNTING_SCOPE = 'managed_successful_sends_only_no_legacy_backfill';
